import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { FileService, SupportDataService, StoreService } from '../../_services'
import { IStorePhoto, ITag } from '../../_entities';
import { FileBase } from './file-base';

@Component({
	selector: 'file-photos',
	template: require('./photo.component.html')
})
export class PhotoComponent extends FileBase implements OnInit {

	constructor(
		private fileService: FileService,
		private supportData: SupportDataService) {
		super();
		this.tags = this.supportData.getPhotoTags();
	}

	tags: Promise<ITag[]>;

	@Input() enableUpload: boolean = false;

	@Input() portletColor: string;

	@Input() uploadUrl: string;

	@Input() files: IStorePhoto[];

	@Input() tag: string;

	@Output('onUploaded') onUploadedCallback = new EventEmitter();

	@Output('onDeleted') onDeletedCallback = new EventEmitter();

	@Output('onChange') onChangeCallback = new EventEmitter();

	ngOnInit() { }

	confirmDelete(id, event) {
		this.fileService.deleteFile(id).then(() => {
			this.onDeletedCallback.emit(id);
		});
	}

	onChange(id, event) {
		this.onChangeCallback.emit({ id, event });
	}

	list() { }

	grid() { }
}




// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular2-router-loader/src!./TypeScript/shared/file/photo.component.ts